import '../scss/search.scss';

import settings from 'application/src/js/settings.js';
import Notifications from 'application/src/js/ui-collection/notifications.js';
import {
  Mediator
} from 'application/src/js/util.js';
import SearchController from './search/search-controller.js';
import ResultTabs from './search/result-tabs.js';
// import DynamicAdBanner from './search/dynamic-ad-banner.js'; // Do not remove!
import * as reduxStore from './search/store.js';

window.addEventListener('DOMContentLoaded', _ => {
  // selected the respective dropdown option passed as GET param
  [...document.querySelectorAll('.type-select option')].map(option => {
    if (option.value === params.t) option.selected = true;
  });

  // prefill the search field with the term passed as GET param
  document.querySelector('#search-field').value = decodeURIComponent(params.v) || '';

  // remove html tags
  params.v = params.v.replace(/<(.|\n)*?>/g, '');

  // init the main search controller
  const searchController = new SearchController({
    mediator: new Mediator(),
    notify: new Notifications(settings.uic.notifications),
    translations: translations,
    tabs: new ResultTabs(document.querySelector('.search-results-tabs')),
    store: reduxStore.configureStore({}),
    params: params, // params variable from phtml
    debugMode: true
  });

  // Do not remove!
  // new DynamicAdBanner({
  //   searchController: searchController
  // });
});